import moment from "moment";
import get from "lodash/get";

const _ = { get };

export const helperFunctionForCountry = (payload) => {
  switch (payload) {
    case "at":
      return "Austria";
    case "be":
      return "Belgium";
    case "bg":
      return "Bulgaria";
    case "hr":
      return "Croatia";
    case "cy":
      return "Cyprus";
    case "cz":
      return "Czech Republic";
    case "dk":
      return "Denmark";
    case "fr":
      return "France";
    case "de":
      return "Germany";
    case "gr":
      return "Greece";
    case "hu":
      return "Hungary";
    case "it":
      return "Italy";
    case "lv":
      return "Latvia";
    case "li":
      return "Liechtenstein";
    case "lt":
      return "Lithuania";
    case "nl":
      return "Netherlands";
    case "pl":
      return "Poland";
    case "pt":
      return "Portugal";
    case "sk":
      return "Slovakia";
    case "es":
      return "Spain";
    case "se":
      return "Sweden";
    case "ch":
      return "Switzerland";
    case "ua":
      return "Ukraine";
    case "uk":
      return "United Kingdom";

    default:
      break;
  }
};

export const helperFunctionForBooleanValue = (payload) => {
  switch (payload) {
    case false:
      return "No";
    case true:
      return "Yes";
    case "true":
      return "Yes";
    case "false":
      return "No";
    default:
      return "N/A";
  }
};

export const helperFunctionForDate = (payload) => {
  return moment(payload).format("DD-MM-YYYY");
};

export const helperFunctionForTime = (payload) => {
  return moment(payload).format("LT");
};

export const helperFunctionForStatus = (payload, elements) => {
  switch (payload) {
    case "APPROVED":
      return _.get(elements, "statusElement.approvedElement", "Approved");
    case "REJECTED":
      return _.get(elements, "statusElement.rejectedElement", "Rejected");
    case "PENDING":
      return _.get(elements, "statusElement.pendingElement", "Pending");
    case "UNALLOCATED":
      return _.get(elements, "statusElement.unallocatedElement", "Unallocated");
    case "LAUNCHED":
      return _.get(elements, "statusElement.launchedElement", "Launched");
    case "UPCOMING":
      return _.get(elements, "statusElement.upcomingElement", "Upcoming");
    case "PROPOSED":
      return _.get(elements, "statusElement.proposedElement", "Proposed");
    case "CANCELED":
      return _.get(elements, "statusElement.cancelledElement", "Cancelled");
    case "SUSPENDED":
      return _.get(elements, "statusElement.suspendedElement", "Suspended");
    case "EASY":
      return _.get(elements, "statusElement.easyElement", "Easy");
    case "MEDIUM":
      return _.get(elements, "statusElement.mediumElement", "Medium");
    case "DIFFICULT":
      return _.get(elements, "statusElement.difficultElement", "Difficult");
    case "JOINED":
      return _.get(elements, "statusElement.joinedElement", "Joined");
    case "COMPLETED":
      return _.get(elements, "statusElement.completedElement", "Completed");
    case "ONGOING":
      return _.get(elements, "statusElement.ongoingElement", "Ongoing");

    default:
      return _.get(elements, "statusElement.nAElement", "N/A");
  }
};

export const helperFunctionForCategory = (payload) => {
  switch (payload) {
    case "EVENTS":
      return "Event";
    case "RIDES":
      return "Ride";
    default:
      return "N/A";
  }
};

/** Reg X Expressions */

export const nameValidation = /^[a-zA-Z0-9\u00c0-\u017e@. \n]*$/i;

export const emailValidation = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

export const numberValidation = /^[0-9. \n]*$/;

export const vinValidation = /^[a-zA-Z0-9\u00c0-\u017e@./?!#\$%\^\&*\+=_-]*$/i;

export const spaceValidation = /^\S*$/;

export const specialCharacters = /[^a-zA-Z0-9 ]/;
